module.exports = __webpack_public_path__ + "img/emptyimage.7696592a.png";